<button
  class="ui-button"
  [class.ui-button-primary]="isPrimary()"
  [class.ui-button-secondary]="isSecondary()"
  [class.ui-button-ghost]="isGhost()"
  [class.ui-button-sm]="isSmall()"
  [class.ui-button-md]="isMedium()"
  [class.ui-button-lg]="isLarge()"
  [class.ui-button-full-width]="isFullWidth()"
  [attr.type]="type()"
  [disabled]="disabled()"
  (click)="handleClick($event)"
>
  <span class="ui-button-content">
    <ng-content />
  </span>
</button>
